<template>
  <BreadCrumb PageTitle="Liste des Options" />
  <ListeOption />
</template>
  
<script lang="ts">

  import { defineComponent } from "vue";
  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import ListeOption from "../../components/Option/ListeOption.vue";
  
  export default defineComponent({
    name: "ListeOptionPage",
    components: {
      BreadCrumb,
      ListeOption,
    },
  });
</script>